import { useCallback } from 'react';
import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import { getBrowserTimeZone } from '@atlassian/jira-platform-utils-datetime/src/index.tsx';
import { DATE_VALUE_FORMAT, TIME_VALUE_FORMAT, ZONE_VALUE_FORMAT } from '../../constants.tsx';

export const useParseDateTimeAttributeValue = () => {
	const { data } = useCurrentUser();
	const timeZone =
		'timeZone' in data.user && data.user.timeZone ? data.user.timeZone : getBrowserTimeZone();

	const parseDateTimeAttributeValue = useCallback(
		(dateTimeValue: string) => {
			const parsedDate = new Date(dateTimeValue);

			if (!isValid(parsedDate)) {
				fireCmdbErrorAnalytics({
					meta: {
						id: 'insightInlineEditableDateTimeAttribute',
						packageName: 'jiraServicedeskInsightSharedUtils',
						teamName: 'falcons',
					},
					attributes: {
						message: 'Expected to parse a valid date value but failed.',
					},
				});
				throw new Error('Received invalid datetime value in DateTimeEditableAttribute');
			}

			return {
				dateValue: formatInTimeZone(parsedDate, timeZone, DATE_VALUE_FORMAT),
				timeValue: formatInTimeZone(parsedDate, timeZone, TIME_VALUE_FORMAT),
				zoneValue: formatInTimeZone(parsedDate, timeZone, ZONE_VALUE_FORMAT),
			};
		},
		[timeZone],
	);

	return { parseDateTimeAttributeValue };
};
